import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

const FullscreenSpinner = ({
  loading,
  size = '3rem',
}) =>
  loading ?
    <div
      className='d-flex justify-content-center align-items-center'
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: '1000',
        top: '0',
        left: '0',
        backgroundColor: '#000',
        opacity: '0.5',
      }}>
      <Spinner animation='border' role='status' style={{ width: size, height: size }}>
        <span className='visually-hidden'>Cargando...</span>
      </Spinner>
    </div>
    : null
  ;

export default FullscreenSpinner;